import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import Alert from '@mui/material/Alert';
import App from './App';
var rootElement = document.getElementById('root');
var root = ReactDOM.createRoot(rootElement);
root.render(_jsx(_Fragment, { children: (rootElement === null || rootElement === void 0 ? void 0 : rootElement.dataset.apiBaseUrl) ? (_jsx(App, { apiBaseUrl: rootElement.dataset.apiBaseUrl })) : (_jsx(Alert, { severity: "error", children: "API base URL not found, please check the root element configuration" })) }));
